import { defineComponent as _defineComponent } from 'vue'
import CarouselCard from './CarouselCard.vue';
import { buildQuery, parseQueryString } from '../../helpers/url';
import { CatalogState } from 'JS/catalog/store/store';
import { IFacetValue } from 'JS/types/Search';
import { IImageUrls } from 'JS/types/Catalog';
import { useLegacyVuexStore } from 'JS/composables/legacy-vuex-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryFacetCard',
  props: {
    queryString: null,
    facetParamName: null,
    subcatFacetValue: null,
    imageUrls: null
  },
  setup(__props: any) {

const props = __props as {
	queryString: string;
	facetParamName: string;
	subcatFacetValue: IFacetValue;
	imageUrls: IImageUrls;
}

const store = useLegacyVuexStore<CatalogState>();



function categoryCardClick() {
	store.dispatch('updateFacetValue', {
		facetValue: props.subcatFacetValue,
		isSelected: true
	});
}

function getRel(facetValue: IFacetValue): string {
	return facetValue.noFollow === 'True' ? 'nofollow' : 'false';
}

function getHref(facetValue: IFacetValue): string {
	const queryParams = parseQueryString(props.queryString);
	let param = queryParams.find(param => param.name === props.facetParamName);
	// the param for this facet may not be in the url yet
	if (!param) {
		param = { name: props.facetParamName, values: [] };
		queryParams.push(param);
	}
	/**
	 * Reflect the next state of the query string if the facet value was toggled
	 */
	if (facetValue.isSelected) {
		param.values = param.values.filter(value => value !== facetValue.value);
	} else {
		param.values.push(facetValue.value);
	}
	const query = buildQuery(queryParams);
	return window.location.pathname + (query.length ? '?' : '') + query;
}

return { __sfc: true,store, props, categoryCardClick, getRel, getHref, CarouselCard }
}

})